//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/general-ledger/budgets';

export default {
    data: function data() {
        return {
            budget: {},
            import_file: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('import-budget', function (budget) {
            _this.budget = budget;
            Event.$emit('show-small-modal');
        });
    },


    methods: {
        process: function process() {
            var data = new FormData(document.querySelector('.import-form'));
            axios.post(BASE_URL + '/import', data).then(function (response) {
                Event.$emit('edit-budget', response.data);
                Event.$emit('close-small-modal');
            });
        },
        close: function close() {
            Event.$emit('close-small-modal');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/budget/ImportBudget.vue
// module id = jWU0
// module chunks = 0 1